import { render } from "./AdministracionDoctores.vue?vue&type=template&id=bd3a5ed6&scoped=true"
import script from "./AdministracionDoctores.vue?vue&type=script&lang=js"
export * from "./AdministracionDoctores.vue?vue&type=script&lang=js"

import "./AdministracionDoctores.vue?vue&type=style&index=0&id=bd3a5ed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd3a5ed6"]])

export default __exports__